/**
 * V70-S-5 — 승인 근무 4개 유형의 "표시용" 집계 (포함 기준)
 *
 * 서버(getHrKrOvertimeSummary · getMyAttendances includeApprovedWork)는 V70-S-2 원본 분류를 그대로 준다.
 *   원본(raw, 상호 배타): overtimeMinutes = 일반 근무일 06~22, nightMinutes = 일반 근무일 22~06,
 *                          holidayMinutes = 휴일 06~22, holidayNightMinutes = 휴일 22~06
 *
 * 화면·엑셀 표시는 아래 포함 기준을 쓴다 (원본에서 한 번만 변환):
 *   연장근무 = 원본 연장 + 원본 야간      야간근무 = 원본 야간
 *   휴일근무 = 원본 휴일 + 원본 휴일 야간  휴일 야간근무 = 원본 휴일 야간
 *   → 4개 표시값을 모두 더하면 중복. 승인 근무시간 합계 = 표시 연장근무 + 표시 휴일근무
 *
 * 이중 변환 방지: 입력은 원본 키(…Minutes)만, 출력은 다른 키(overtime/night/holiday/holidayNight)만 가진다.
 * 표시값을 다시 이 함수에 넣으면 타입 오류가 난다.
 */
export interface RawApprovedWorkMinutes {
  overtimeMinutes: number;
  nightMinutes: number;
  holidayMinutes: number;
  holidayNightMinutes: number;
}

export interface InclusiveWorkDisplay {
  /** 연장근무 (야간근무 포함) */
  overtime: number;
  /** 야간근무 */
  night: number;
  /** 휴일근무 (휴일 야간근무 포함) */
  holiday: number;
  /** 휴일 야간근무 */
  holidayNight: number;
}

export function toInclusiveWorkDisplay(raw: RawApprovedWorkMinutes): InclusiveWorkDisplay {
  const n = (v: number) => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
  return {
    overtime: n(raw.overtimeMinutes) + n(raw.nightMinutes),
    night: n(raw.nightMinutes),
    holiday: n(raw.holidayMinutes) + n(raw.holidayNightMinutes),
    holidayNight: n(raw.holidayNightMinutes),
  };
}

/** 표시값 기준 승인 근무시간 합계 (= 원본 4개 합) */
export function inclusiveDisplayTotal(d: InclusiveWorkDisplay): number {
  return d.overtime + d.holiday;
}

/** 화면·엑셀 공통 안내 문구 */
export const INCLUSIVE_WORK_NOTE = '연장근무에는 야간근무가 포함되며, 휴일근무에는 휴일 야간근무가 포함됩니다.';
export const INCLUSIVE_WORK_TOTAL_NOTE = '4개 값을 모두 더하면 야간 시간이 중복되므로, 승인 근무시간 합계는 연장근무 + 휴일근무입니다.';
